export default __webpack_public_path__ + "static/media/books2-afterB-1440w.c19484d8.webp";